import campaignServices from './services';
import i18n from 'i18nextInstance';
import isEmpty from 'lodash/isEmpty';
import { push } from 'react-router-redux';
import {
    call,
    put,
    takeEvery
} from 'redux-saga/effects';
import {
    campaignActions,
    parseCampaignParticipants
} from '.';

function* _changeParticipantStatus ({ payload }) {
    try {
        yield put(campaignActions.setCampaignProcessing(true));
        const { participant_id, status } = payload;
        yield call(campaignServices.putParticipantStatus, { participant_id }, { status });
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

function* _getCampaign ({ payload }) {
    try {
        yield put(campaignActions.setCampaignSelected(null));
        yield put(campaignActions.setCampaignLoading(true));
        const { data } = yield call(campaignServices.fetchCampaign, { id: payload });
        yield put(campaignActions.setCampaignSelected(data));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignLoading(false));
    }
}

function* _getCampaignParticipants ({ payload }) {
    try {
        const { id, ...params } = payload;
        yield put(campaignActions.setCampaignParticipantsLoading(true));
        const { data } = yield call(campaignServices.fetchCampaignParticipants, { id }, params);
        const { data: { total_qty } } = yield call(campaignServices.fetchCampaignParticipantsStatus, { id });
        yield put(campaignActions.setCampaignParticipants(data));
        yield put(campaignActions.setCampaignParticipantsStatus(total_qty));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignParticipantsLoading(false));
    }
}

function* _getCampaignParticipantsDownload ({ payload }) {
    try {
        const { id, ...params } = payload;
        yield put(campaignActions.setCampaignParticipantsDownloading(true));
        const { data: { data } } = yield call(campaignServices.fetchCampaignParticipants, { id }, { ...params, one_page: 1 });
        yield put(campaignActions.setCampaignParticipantsDownload(parseCampaignParticipants(data)));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignParticipantsDownloading(false));
    }
}

function* _getCampaigns ({ payload }) {
    try {
        yield put(campaignActions.setCampaignLoading(true));
        const { end_date: effective_end_date, start_date: effective_start_date } = payload;
        const params = {
            effective_end_date,
            effective_start_date
        };
        const { data } = yield call(campaignServices.fetchCampaigns, null, params);
        yield put(campaignActions.setCampaignList({
            ...data,
            filters: params
        }));
    } catch {

    } finally {
        yield put(campaignActions.setCampaignLoading(false));
    }
}

function* _getDonation ({ payload }) {
    try {
        yield put(campaignActions.setCampaignDonationLoading(true));
        const { data } = yield call(campaignServices.fetchDonation, { id: payload });
        yield put(campaignActions.setCampaignDonation(data));
    } catch {

    } finally {
        yield put(campaignActions.setCampaignDonationLoading(false));
    }
}

function* _getTraining ({ payload }) {
    try {
        yield put(campaignActions.setCampaignTrainingLoading(true));
        const { data } = yield call(campaignServices.fetchTraining, { id: payload });
        yield put(campaignActions.setCampaignTraining(data));
    } catch {

    } finally {
        yield put(campaignActions.setCampaignTrainingLoading(false));
    }
}

function* _getVaccination ({ payload }) {
    try {
        yield put(campaignActions.setCampaignVaccinationLoading(true));
        const { data } = yield call(campaignServices.fetchVaccination, { id: payload });
        yield put(campaignActions.setCampaignVaccination(data));
    } catch {

    } finally {
        yield put(campaignActions.setCampaignVaccinationLoading(false));
    }
}

function* _inviteParticipants ({ payload }) {
    try {
        const { id, ...params } = payload;
        yield put(campaignActions.setCampaignProcessing(true));
        yield call(campaignServices.inviteParticipants, { id }, params);
        yield put(campaignActions.setCampaignInvitationSuccess(true));
    } catch {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

function* _upsertCampaign ({ payload }) {
    try {
        yield put(campaignActions.setCampaignProcessing(true));
        const { clone_id, clone_status = [], id, ...body } = payload;
        const { data: { id: creationId } } = !id ? yield call(campaignServices.postCampaign, null, body) : yield call(campaignServices.putCampaign, { id }, body);
        if (clone_id && !isEmpty(clone_status)) {
            yield call(campaignServices.cloneParticipants, { id: creationId }, { campaign_id: clone_id, status: clone_status });
        }
        yield put(push(id ? i18n.t('/campanas') : `${ i18n.t('/campanas/editar') }/${ creationId }`));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

function* _upsertDonation ({ payload }) {
    try {
        yield put(campaignActions.setCampaignProcessing(true));
        const { donation_id, participant_id, ...body } = payload;
        const { data: { id } } = !donation_id
            ? yield call(campaignServices.postDonation, { participant_id }, body)
            : yield call(campaignServices.putDonation, { donation_id }, body);
        yield put(campaignActions.setCampaignDonationSuccess(id));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

function* _upsertTraining ({ payload }) {
    try {
        yield put(campaignActions.setCampaignProcessing(true));
        const { participant_id, training_id, ...body } = payload;
        const { data: { id } } = !training_id
            ? yield call(campaignServices.postTraining, { participant_id }, body)
            : yield call(campaignServices.putTraining, { training_id }, body);
        yield put(campaignActions.setCampaignTrainingSuccess(id));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

function* _upsertVaccination ({ payload }) {
    try {
        yield put(campaignActions.setCampaignProcessing(true));
        const { participant_id, vaccination_id, ...body } = payload;
        const { data: { id } } = !vaccination_id
            ? yield call(campaignServices.postVaccination, { participant_id }, body)
            : yield call(campaignServices.putVaccination, { vaccination_id }, body);
        yield put(campaignActions.setCampaignVaccinationSuccess(id));
    } catch (e) {

    } finally {
        yield put(campaignActions.setCampaignProcessing(false));
    }
}

export default [
    takeEvery(campaignActions.changeParticipantStatus.type, _changeParticipantStatus),
    takeEvery(campaignActions.getCampaign.type, _getCampaign),
    takeEvery(campaignActions.getCampaignParticipants.type, _getCampaignParticipants),
    takeEvery(campaignActions.getCampaignParticipantsDownload.type, _getCampaignParticipantsDownload),
    takeEvery(campaignActions.getCampaigns.type, _getCampaigns),
    takeEvery(campaignActions.getDonation.type, _getDonation),
    takeEvery(campaignActions.getTraining.type, _getTraining),
    takeEvery(campaignActions.getVaccination.type, _getVaccination),
    takeEvery(campaignActions.inviteParticipants.type, _inviteParticipants),
    takeEvery(campaignActions.upsertCampaign.type, _upsertCampaign),
    takeEvery(campaignActions.upsertDonation.type, _upsertDonation),
    takeEvery(campaignActions.upsertTraining.type, _upsertTraining),
    takeEvery(campaignActions.upsertVaccination.type, _upsertVaccination)
];
